export type DisasterLevel = "Rendah" | "Sedang" | "Parah";
export type StatusLevel = "Banjir Bandang" | "Banjir" | "Tanah Longsor" | "Tsunami" | "Erupsi Gunung";

export interface CityData {
  name: string;
  poverty?: number;
  disaster?: {
    level: DisasterLevel;
    status: StatusLevel;
  };
}

export type ProvinceData = Record<string, CityData[]>;

export const provinceData: ProvinceData = {
  // ======================
  // 🟡 LAMPUNG (BENCANA)
  // ======================
  lampung: [
    // {
    //   name: "Lampung Selatan",
    //   disaster: { level: "Parah", status: "Banjir" },
    // },
    // {
    //   name: "Lampung Timur",
    //   disaster: { level: "Sedang", status: "Tanah Longsor" },
    // },
    // {
    //   name: "Lampung Utara",
    //   disaster: { level: "Rendah", status: "Banjir" },
    // },

    { name: "Lampung Timur", poverty: 132.17 },
    { name: "Lampung Tengah", poverty: 127.83 },
    { name: "Lampung Selatan", poverty: 127.74 },
    { name: "Lampung Utara", poverty: 98.99 },
    { name: "Bandar Lampung", poverty: 80.19 },
    { name: "Tanggamus", poverty: 63.56 },
    { name: "Pasawaran", poverty: 51.09 },
    { name: "Way Kanan", poverty: 44.17 },
  ],

  // ======================
  // 🔴 ACEH
  // ======================
  "di. aceh": [
    { name: "Aceh Singkil", poverty: 132.2 },
    { name: "Aceh Barat", poverty: 122.1 },
    { name: "Pidie", poverty: 112.21 },
    { name: "Aceh Utara", poverty: 98.3 },
    { name: "Pidie Jaya", poverty: 77.7 },
    // {
    //   name: "Lampung Selatan",
    //   disaster: { level: "Parah", status: "Banjir" },
    // },
  ],

  // ======================
  // 🔴 SUMATERA UTARA
  // ======================
  "sumatera utara": [
    { name: "Kota Medan", poverty: 171.6 },
    { name: "Langkat", poverty: 90.28 },
    { name: "Deli Serdang", poverty: 77.7 },
    { name: "Simalungun", poverty: 61.12 },
    { name: "Assahan", poverty: 54.57 },
    { name: "Nias Selatan", poverty: 54.29 },
    { name: "Tapanuli Tengah", poverty: 46.79 },
    { name: "Batu Bara", poverty: 44.28 },
  ],

  // ======================
  // 🔴 SUMATERA BARAT
  // ======================
  "sumatera barat": [
    { name: "Kepulauan Mentawai", poverty: 162.9 },
    { name: "Pasaman Barat", poverty: 151.1 },
    { name: "Pesisir Selatan", poverty: 142.2 },
    { name: "Agam", poverty: 125.4 },
  ],

  // ======================
  // 🔴 RIAU
  // ======================
  // riau: [
  //   { name: "Pelalawan", poverty: 11.3 },
  //   { name: "Rokan Hulu", poverty: 12.1 },
  //   { name: "Kepulauan Meranti", poverty: 13.7 },
  // ],

  // ======================
  // 🔴 JAMBI
  // ======================
  // jambi: [
  //   { name: "Tanjung Jabung Timur", poverty: 13.0 },
  //   { name: "Tanjung Jabung Barat", poverty: 12.8 },
  //   { name: "Kota Jambi", poverty: 9.2 },
  // ],

  // ======================
  // 🔴 SUMATERA SELATAN
  // ======================
  "sumatera selatan": [
    { name: "Kota Palembang", poverty: 162.3 },
    { name: "Ogan Komering Ilir", poverty: 105.26 },
    { name: "Banyuasin", poverty: 77.63 },
    { name: "Musi Banyuasin", poverty: 69.81 },
    { name: "Muara Enim", poverty: 64.82 },
    { name: "Oku Timur", poverty: 62.89 },
    { name: "Lahat", poverty: 58.66 },
    { name: "Musi Rawas", poverty: 54.7 },
  ],

  // ======================
  // 🔴 BENGKULU
  // ======================
  // bengkulu: [
  //   { name: "Bengkulu Selatan", poverty: 14.8 },
  //   { name: "Seluma", poverty: 15.3 },
  // ],

  // ======================
  // 🔴 KEP. BANGKA BELITUNG
  // ======================
  // "bangka belitung": [
  //   { name: "Belitung", poverty: 10.9 },
  //   { name: "Belitung Timur", poverty: 11.2 },
  // ],

  // ======================
  // 🔴 KEP. RIAU
  // ======================
  // "kepulauan riau": [{ name: "Kota Batam", poverty: 6.8 }],

  // ======================
  // 🔴 DKI JAKARTA
  // ======================
  // "dki jakarta": [
  //   { name: "Kota Jakarta Timur", poverty: 4.9 },
  //   { name: "Kota Jakarta Utara", poverty: 5.1 },
  // ],

  // ======================
  // 🔴 JAWA BARAT
  // ======================
  "jawa barat": [
    { name: "Bogor", poverty: 401.86 },
    { name: "Bandung", poverty: 236.06 },
    { name: "Garut", poverty: 252.56 },
    { name: "Cianjur", poverty: 232.61 },
    { name: "Cirebon", poverty: 229.64 },
    { name: "Indramayu", poverty: 196.78 },
    { name: "Bekasi", poverty: 191 },
    { name: "Tasikmalaya", poverty: 165.99 },
  ],

  // ======================
  // 🔴 JAWA TENGAH
  // ======================
  "jawa tengah": [
    { name: "Brebes", poverty: 257.9 },
    { name: "Banyumas", poverty: 194.87 },
    { name: "Pemalang", poverty: 173.38 },
    { name: "Cilacap", poverty: 164.22 },
    { name: "Kebumen", poverty: 162.54 },
    { name: "Grobogan", poverty: 148.1 },
    { name: "Magelang", poverty: 132.21 },
    { name: "Demak", poverty: 131.47 },
  ],

  // ======================
  // 🔴 DIY YOGYAKARTA
  // ======================
  // "daerah istimewa yogyakarta": [{ name: "Gunung Kidul", poverty: 15.6 }],

  // ======================
  // 🔴 JAWA TIMUR
  // ======================
  "jawa timur": [
    { name: "Malang", poverty: 235.63 },
    { name: "Jember", poverty: 216.76 },
    { name: "Sampang", poverty: 213.98 },
    { name: "Probolinggo", poverty: 196.26 },
    { name: "Sumenep", poverty: 188.48 },
    { name: "Bangkalan", poverty: 187.9 },
    { name: "Tuban", poverty: 168.86 },
    { name: "Kediri", poverty: 57.47 },
  ],

  // ======================
  // 🔴 BANTEN
  // ======================
  probanten: [
    { name: "Tangerang", poverty: 265.9 },
    { name: "Kota Tangerang", poverty: 124.76 },
    { name: "Lebak", poverty: 106.52 },
    { name: "Pandeglang", poverty: 105.35 },
    { name: "Serang", poverty: 68.51 },
    { name: "Kota Tangerang Selatan", poverty: 44.61 },
    { name: "Kota Serang", poverty: 41.07 },
    { name: "Kota Cilegon", poverty: 16.05 },
  ],

  // ======================
  // 🔴 BALI
  // ======================
  // bali: [
  //   { name: "Buleleng", poverty: 9.8 },
  //   { name: "Karang Asem", poverty: 13.2 },
  // ],

  // ======================
  // 🔴 NUSA TENGGARA BARAT
  // ======================
  "nusatenggara barat": [
    { name: "Lombok Timur", poverty: 110.28 },
    { name: "Lombok Utara", poverty: 63.89 },
    { name: "Sumbawa Timur", poverty: 32.76 },
  ],

  // ======================
  // 🔴 NUSA TENGGARA TIMUR
  // ======================
  "nusa tenggara timur": [
    { name: "Timor Tengah Selatan", poverty: 116.74 },
    { name: "Sumba Barat Daya", poverty: 97.68 },
    { name: "Kupang", poverty: 87.5 },
    { name: "Manggarai Timur", poverty: 70.99 },
    { name: "Sumba Timur", poverty: 70.35 },
    { name: "Manggarai", poverty: 65.81 },
    { name: "Ende", poverty: 58.92 },
    { name: "Timor Tengah Selatan", poverty: 53.44 },
  ],

  // ======================
  // 🔴 KALIMANTAN BARAT
  // ======================
  // "kalimantan barat": [
  //   { name: "Landak", poverty: 13.3 },
  //   { name: "Ketapang", poverty: 12.9 },
  //   { name: "Melawi", poverty: 14.1 },
  //   { name: "Kotawaringin Timur", poverty: 11.7 },
  //   { name: "Seruyan", poverty: 12.5 },
  // ],

  // ======================
  // 🔴 KALIMANTAN TENGAH
  // ======================
  // "kalimantan tengah": [{ name: "Barito Timur", poverty: 13.6 }],

  // ======================
  // 🔴 KALIMANTAN SELATAN
  // ======================
  // "kalimantan selatan": [
  //   { name: "Hulu Sungai Tengah", poverty: 12.2 },
  //   { name: "Hulu Sungai Utara", poverty: 13.0 },
  //   { name: "Kota Banjarmasin", poverty: 7.9 },
  // ],

  // ======================
  // 🔴 KALIMANTAN TIMUR
  // ======================
  // "kalimantan timur": [
  //   { name: "Kutai Kartanegara", poverty: 10.4 },
  //   { name: "Kutai Timur", poverty: 11.0 },
  // ],

  // ======================
  // 🔴 KALIMANTAN UTARA
  // ======================
  // "kalimantan utara": [{ name: "Bulungan", poverty: 12.6 }],

  // ======================
  // 🔴 SULAWESI UTARA
  // ======================
  // "sulawesi utara": [
  //   { name: "Kepulauan Sangihe", poverty: 14.8 },
  //   { name: "Minahasa Tenggara", poverty: 12.3 },
  // ],

  // ======================
  // 🔴 SULAWESI TENGAH
  // ======================
  // "sulawesi tengah": [
  //   { name: "Bolaang Mongondow Selatan", poverty: 15.4 },
  //   { name: "Donggala", poverty: 14.9 },
  //   { name: "Parigi Moutong", poverty: 13.8 },
  //   { name: "Tojo Una-Una", poverty: 14.2 },
  // ],

  // ======================
  // 🔴 SULAWESI SELATAN
  // ======================
  // "sulawesi selatan": [
  //   { name: "Jeneponto", poverty: 16.1 },
  //   { name: "Pangkajene dan Kepulauan", poverty: 12.7 },
  //   { name: "Bone", poverty: 11.9 },
  //   { name: "Luwu", poverty: 13.5 },
  //   { name: "Luwu Utara", poverty: 14.3 },
  // ],

  // ======================
  // 🔴 SULAWESI TENGGARA
  // ======================
  // "sulawesi tenggara": [
  //   { name: "Muna", poverty: 15.6 },
  //   { name: "Konawe", poverty: 13.4 },
  //   { name: "Wakatobi", poverty: 11.8 },
  //   { name: "Konawe Kepulauan", poverty: 14.0 },
  // ],

  // ======================
  // 🔴 GORONTALO
  // ======================
  // gorontalo: [
  //   { name: "Boalemo", poverty: 14.9 },
  //   { name: "Gorontalo", poverty: 12.5 },
  // ],

  // ======================
  // 🔴 SULAWESI BARAT
  // ======================
  // "sulawesi barat": [
  //   { name: "Polewali Mandar", poverty: 13.7 },
  //   { name: "Mamasa", poverty: 16.8 },
  // ],

  // ======================
  // MALUKU
  // ======================
  // maluku: [
  //   { name: "Maluku Tenggara Barat", poverty: 22.1 }, // Kepulauan Tanimbar
  //   { name: "Seram Bagian Barat", poverty: 20.3 },
  //   { name: "Maluku Barat Daya", poverty: 23.4 },
  // ],

  // ======================
  // MALUKU UTARA
  // ======================
  // "maluku utara": [
  //   { name: "Halmahera Tengah", poverty: 19.8 },
  //   { name: "Halmahera Timur", poverty: 21.2 },
  // ],

  // ======================
  // PAPUA BARAT
  // ======================
  // "irian jaya barat": [
  //   { name: "Teluk Wondama", poverty: 27.6 },
  //   { name: "Pegunungan Arfak", poverty: 30.2 },
  //   { name: "Tambrauw", poverty: 31.4 },
  //   { name: "Maybrat", poverty: 29.8 },
  // ],

  // ======================
  // PAPUA TENGAH
  // ======================
  // "irian jaya tengah": [
  //   { name: "Paniai", poverty: 32.7 },
  //   { name: "Intan Jaya", poverty: 34.1 },

  //   { name: "Nduga", poverty: 36.9 },
  //   { name: "Lanny Jaya", poverty: 35.2 },
  // ],

  // ======================
  // PAPUA TIMUR
  // ======================
  // "irian jaya timur": [
  //   { name: "Supiori", poverty: 25.4 },
  //   { name: "Mamberamo Raya", poverty: 28.6 },
  //   { name: "Mappi", poverty: 26.9 },
  // ],
};
